import { apiCall } from '../apiServerHelper'
import { apis } from '../apiUrls'
import { UrlBuilder } from '../helpers'

/**
 * Fetch median prices for a suburb with optional filters
 * @param {string} slug - Suburb slug
 * @param {Object} params - Filter parameters { type: 'house'|'unit'|'commercial', bedrooms: number|'Overall' }
 */
export const getMedianPrices = async (slug, params = {}) => {
  const url = `${apis.PROPTRACK_SUBURB}${slug}/median-prices/`
  return await apiCall(UrlBuilder(url, params))
}

/**
 * Fetch five year growth data for a suburb with optional filters
 * @param {string} slug - Suburb slug
 * @param {Object} params - Filter parameters { type: 'house'|'unit'|'commercial', bedrooms: number|'Overall' }
 */
export const getFiveYearGrowth = async (slug, params = {}) => {
  const url = `${apis.PROPTRACK_SUBURB}${slug}/five-year-growth/`
  return await apiCall(UrlBuilder(url, params))
}

/**
 * Fetch investor statistics for a suburb with optional filters
 * @param {string} slug - Suburb slug
 * @param {Object} params - Filter parameters { type: 'house'|'unit'|'commercial', bedrooms: number|'Overall' }
 */
export const getInvestorStats = async (slug, params = {}) => {
  const url = `${apis.PROPTRACK_SUBURB}${slug}/investor-stats/`
  return await apiCall(UrlBuilder(url, params))
}

/**
 * Fetch sales comparison data for a suburb with optional filters
 * @param {string} slug - Suburb slug
 * @param {Object} params - Filter parameters { type: 'house'|'unit'|'commercial', bedrooms: number|'Overall' }
 */
export const getSalesComparison = async (slug, params = {}) => {
  const url = `${apis.PROPTRACK_SUBURB}${slug}/sales-comparison/`
  return await apiCall(UrlBuilder(url, params))
}

